// 配信停止者向けのエレガントなモーダルコンポーネント

export function showUnsubscribeModal(email) {
  // 既存のモーダルがあれば削除
  const existingModal = document.getElementById('unsubscribe-modal');
  if (existingModal) {
    existingModal.remove();
  }

  // モーダルのHTML作成
  const modalHtml = `
    <div id="unsubscribe-modal" class="modal-overlay">
      <div class="modal-container">
        <div class="modal-content">
          <!-- アイコンセクション -->
          <div class="modal-icon-section">
            <div class="modal-icon-wrapper">
              <svg class="modal-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 9V13M12 17H12.01M5 19H19C20.1046 19 21 18.1046 21 17V7C21 5.89543 20.1046 5 19 5H5C3.89543 5 3 5.89543 3 7V17C3 18.1046 3.89543 19 5 19Z" stroke="#DC143C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
          </div>

          <!-- コンテンツセクション -->
          <div class="modal-text-section">
            <h2 class="modal-title">レポートダウンロードの制限</h2>
            <p class="modal-subtitle">配信停止済みアカウント</p>

            <div class="modal-email-badge">
              <span class="email-icon">📧</span>
              <span class="email-text">${email}</span>
            </div>

            <div class="modal-message">
              <p>このメールアドレスは配信停止済みのため、<br>
              レポートのダウンロードが制限されています。</p>
            </div>

            <div class="modal-restrictions">
              <div class="restriction-header">
                <svg class="info-icon" width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
                  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                  <path d="M8 4a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-1 0v-3A.5.5 0 0 1 8 4zm0 6a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1z"/>
                </svg>
                <span>制限内容</span>
              </div>
              <ul class="restriction-list">
                <li>
                  <span class="restriction-icon">❌</span>
                  <span>すべてのレポートダウンロード</span>
                </li>
                <li>
                  <span class="restriction-icon">❌</span>
                  <span>同一メールアドレスでの再登録</span>
                </li>
                <li>
                  <span class="restriction-icon">❌</span>
                  <span>過去レポートの再取得</span>
                </li>
              </ul>
            </div>

            <div class="modal-suggestion">
              <p class="suggestion-title">💡 解決方法</p>
              <p class="suggestion-text">
                新しいメールアドレスで登録することで、<br>
                レポートのダウンロードが可能になります。
              </p>
            </div>
          </div>

          <!-- アクションセクション -->
          <div class="modal-actions">
            <button class="btn-primary" onclick="document.getElementById('unsubscribe-modal').remove()">
              閉じる
            </button>
          </div>

          <!-- 閉じるボタン -->
          <button class="modal-close" onclick="document.getElementById('unsubscribe-modal').remove()">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            </svg>
          </button>
        </div>
      </div>
    </div>
  `;

  // スタイルの作成
  const styleElement = document.createElement('style');
  styleElement.id = 'unsubscribe-modal-styles';
  styleElement.textContent = `
    /* モーダルオーバーレイ */
    .modal-overlay {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.7);
      backdrop-filter: blur(5px);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 99999;
      animation: fadeIn 0.3s ease-out;
      padding: 20px;
    }

    /* モーダルコンテナ */
    .modal-container {
      width: 100%;
      max-width: 520px;
      max-height: 90vh;
      overflow-y: auto;
      animation: slideUp 0.3s ease-out;
    }

    .modal-content {
      background: white;
      border-radius: 16px;
      box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
      position: relative;
      overflow: hidden;
    }

    /* アイコンセクション */
    .modal-icon-section {
      background: linear-gradient(135deg, #fff5f5 0%, #ffe0e0 100%);
      padding: 32px 24px 24px;
      text-align: center;
      border-bottom: 1px solid rgba(220, 20, 60, 0.1);
    }

    .modal-icon-wrapper {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 72px;
      height: 72px;
      background: white;
      border-radius: 50%;
      box-shadow: 0 4px 12px rgba(220, 20, 60, 0.2);
    }

    .modal-icon {
      width: 40px;
      height: 40px;
      animation: pulse 2s infinite;
    }

    /* テキストセクション */
    .modal-text-section {
      padding: 32px 32px 24px;
    }

    .modal-title {
      font-size: 24px;
      font-weight: bold;
      color: #1a1a1a;
      margin: 0 0 8px 0;
      text-align: center;
    }

    .modal-subtitle {
      font-size: 14px;
      color: #DC143C;
      text-align: center;
      margin: 0 0 24px 0;
      font-weight: 500;
      text-transform: uppercase;
      letter-spacing: 1px;
    }

    /* メールアドレスバッジ */
    .modal-email-badge {
      display: inline-flex;
      align-items: center;
      gap: 8px;
      background: #f8f9fa;
      padding: 8px 16px;
      border-radius: 100px;
      margin: 0 auto 24px;
      border: 1px solid #e9ecef;
      width: fit-content;
      display: flex;
      justify-content: center;
    }

    .email-icon {
      font-size: 16px;
    }

    .email-text {
      font-size: 14px;
      font-weight: 500;
      color: #495057;
      font-family: 'SF Mono', Monaco, monospace;
    }

    /* メッセージ */
    .modal-message {
      text-align: center;
      margin-bottom: 24px;
    }

    .modal-message p {
      color: #666;
      font-size: 15px;
      line-height: 1.6;
      margin: 0;
    }

    /* 制限内容 */
    .modal-restrictions {
      background: #fff5f5;
      border: 1px solid #ffdddd;
      border-radius: 12px;
      padding: 20px;
      margin-bottom: 24px;
    }

    .restriction-header {
      display: flex;
      align-items: center;
      gap: 8px;
      margin-bottom: 16px;
      color: #DC143C;
      font-weight: 600;
      font-size: 14px;
    }

    .info-icon {
      width: 16px;
      height: 16px;
    }

    .restriction-list {
      list-style: none;
      padding: 0;
      margin: 0;
    }

    .restriction-list li {
      display: flex;
      align-items: center;
      gap: 12px;
      padding: 8px 0;
      color: #666;
      font-size: 14px;
    }

    .restriction-icon {
      font-size: 14px;
      flex-shrink: 0;
    }

    /* 提案セクション */
    .modal-suggestion {
      background: #f0f8ff;
      border: 1px solid #b0d4ff;
      border-radius: 12px;
      padding: 20px;
      margin-bottom: 24px;
    }

    .suggestion-title {
      color: #0066cc;
      font-weight: 600;
      font-size: 14px;
      margin: 0 0 8px 0;
    }

    .suggestion-text {
      color: #495057;
      font-size: 14px;
      line-height: 1.6;
      margin: 0;
    }

    /* アクションボタン */
    .modal-actions {
      display: flex;
      gap: 12px;
      padding: 0 32px 32px;
    }

    .btn-primary, .btn-secondary {
      flex: 1;
      padding: 12px 24px;
      border-radius: 8px;
      font-size: 15px;
      font-weight: 600;
      text-align: center;
      cursor: pointer;
      transition: all 0.2s ease;
      border: none;
      text-decoration: none;
      display: inline-block;
    }

    .btn-primary {
      background: #DC143C;
      color: white;
    }

    .btn-primary:hover {
      background: #B91C3C;
      transform: translateY(-1px);
      box-shadow: 0 4px 12px rgba(220, 20, 60, 0.3);
    }

    .btn-secondary {
      background: #f8f9fa;
      color: #495057;
      border: 1px solid #dee2e6;
    }

    .btn-secondary:hover {
      background: #e9ecef;
    }

    /* 閉じるボタン */
    .modal-close {
      position: absolute;
      top: 16px;
      right: 16px;
      width: 36px;
      height: 36px;
      border-radius: 50%;
      background: white;
      border: none;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 0.2s ease;
      color: #666;
    }

    .modal-close:hover {
      background: #f8f9fa;
      color: #DC143C;
    }

    /* アニメーション */
    @keyframes fadeIn {
      from {
        opacity: 0;
      }
      to {
        opacity: 1;
      }
    }

    @keyframes slideUp {
      from {
        transform: translateY(20px);
        opacity: 0;
      }
      to {
        transform: translateY(0);
        opacity: 1;
      }
    }

    @keyframes pulse {
      0%, 100% {
        transform: scale(1);
      }
      50% {
        transform: scale(1.05);
      }
    }

    /* レスポンシブ対応 */
    @media (max-width: 640px) {
      .modal-container {
        max-width: 100%;
      }

      .modal-text-section {
        padding: 24px 20px 20px;
      }

      .modal-actions {
        padding: 0 20px 24px;
        flex-direction: column;
      }

      .btn-primary, .btn-secondary {
        width: 100%;
      }

      .modal-title {
        font-size: 20px;
      }

      .modal-email-badge {
        font-size: 12px;
      }
    }
  `;

  // スタイルとHTMLをDOMに追加
  if (!document.getElementById('unsubscribe-modal-styles')) {
    document.head.appendChild(styleElement);
  }

  const modalContainer = document.createElement('div');
  modalContainer.innerHTML = modalHtml;
  document.body.appendChild(modalContainer.firstElementChild);

  // ESCキーで閉じる
  const handleEsc = (e) => {
    if (e.key === 'Escape') {
      const modal = document.getElementById('unsubscribe-modal');
      if (modal) modal.remove();
      document.removeEventListener('keydown', handleEsc);
    }
  };
  document.addEventListener('keydown', handleEsc);

  // オーバーレイクリックで閉じる
  const overlay = document.getElementById('unsubscribe-modal');
  overlay.addEventListener('click', (e) => {
    if (e.target === overlay) {
      overlay.remove();
    }
  });
}

// 購入者向けのモーダル
export function showPurchaserModal(email) {
  // 既存のモーダルがあれば削除
  const existingModal = document.getElementById('purchaser-modal');
  if (existingModal) {
    existingModal.remove();
  }

  const modalHtml = `
    <div id="purchaser-modal" class="modal-overlay">
      <div class="modal-container">
        <div class="modal-content">
          <!-- アイコンセクション（青色版） -->
          <div class="modal-icon-section" style="background: linear-gradient(135deg, #f0f8ff 0%, #d0e8ff 100%);">
            <div class="modal-icon-wrapper">
              <svg class="modal-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="#0066cc" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
          </div>

          <!-- コンテンツセクション -->
          <div class="modal-text-section">
            <h2 class="modal-title">購入済みアカウント</h2>
            <p class="modal-subtitle" style="color: #0066cc;">PREMIUM MEMBER</p>

            <div class="modal-email-badge">
              <span class="email-icon">🎯</span>
              <span class="email-text">${email}</span>
            </div>

            <div class="modal-message">
              <p>このアカウントは既に教材を購入済みです。<br>
              無料レポートのダウンロードは不要です。</p>
            </div>

            <div class="modal-suggestion" style="background: #f0f8ff; border-color: #b0d4ff;">
              <p class="suggestion-title" style="color: #0066cc;">✨ 購入者様専用コンテンツ</p>
              <p class="suggestion-text">
                メンバーサイトから、より詳しい教材や<br>
                限定コンテンツにアクセスできます。
              </p>
            </div>
          </div>

          <!-- アクションセクション -->
          <div class="modal-actions">
            <button class="btn-primary" style="background: #0066cc;" onclick="document.getElementById('purchaser-modal').remove()">
              閉じる
            </button>
          </div>

          <!-- 閉じるボタン -->
          <button class="modal-close" onclick="document.getElementById('purchaser-modal').remove()">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            </svg>
          </button>
        </div>
      </div>
    </div>
  `;

  const modalContainer = document.createElement('div');
  modalContainer.innerHTML = modalHtml;
  document.body.appendChild(modalContainer.firstElementChild);

  // 同じスタイルを適用（既に追加済みなら再追加しない）
  if (!document.getElementById('unsubscribe-modal-styles')) {
    const styleElement = document.createElement('style');
    styleElement.id = 'unsubscribe-modal-styles';
    // スタイルは上記と同じものを使用
    document.head.appendChild(styleElement);
  }
}